import _ from '../../core/utils'
import CASES_CONFIG from './config'
import MAP_CASES from '../map-cases'
import API from '../api'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

class CasesClass {
    constructor() {
        this.DOM = {
            section: CASES_CONFIG.section,
            grid: {
                wrap: CASES_CONFIG.grid.wrap,
                items: CASES_CONFIG.grid.items,
                noresults: CASES_CONFIG.grid.noresults
            },
            search: {
                form: CASES_CONFIG.search.form,
                input: CASES_CONFIG.search.input,
                clear: CASES_CONFIG.search.clear,
                loader: CASES_CONFIG.search.loader,
                submit: CASES_CONFIG.search.submit,
            },
            filter: CASES_CONFIG.filter,
            markers: null
        }

        this.searched = false
        this.filtered = false
        this.endpoint = CASES_CONFIG.endpoint
        this.isotope = null
        this.DOM.section ? this.init() : null
    }

    init() {
        this._listeners()
        this._isotope()
        console.log( this )
    }

    _listeners() {
        this.DOM.search.form.addEventListener( 'submit', this._search.bind( this ) )
        this.DOM.search.clear.addEventListener( 'click', this._clear.bind( this ) )
        this.DOM.filter.addEventListener( 'change', this._filter.bind( this ) )
    }

    _isotope() {
        this.isotope = new Isotope ( this.DOM.grid.wrap, {
        })

        imagesLoaded( this.DOM.grid.wrap ).on( 'progress', () => {
            this.isotope.arrange({
                filter: '.fl__card--case'
            })
        })
    }

    _filter() {
        let value = event.target.value,
            flyed = false

        this._filterMarkers( value, flyed )
        this._filterCards( value )
        this._allowed()
    }

    _filterMarkers( value, flyed) {
        this.DOM.markers = _.selectAll( '.fl__marker' )

        // Map
        this.DOM.markers.forEach( ( marker, key ) => {
            _.removeClass( marker, 'fl__marker--hidden' )
            if ( value != 'all' ) {
                if( marker.getAttribute( 'data-country' ) === value ) {
                    if ( !flyed ) {
                        MAP_CASES.mapbox.flyTo({
                            center: [
                                marker.getAttribute( 'data-longitude' ),
                                marker.getAttribute( 'data-latitude' )
                            ],
                            zoom: 4,
                            essential: true
                        })

                        flyed = true
                    }
                } else {
                    _.addClass( marker, 'fl__marker--hidden' ) 
                }
                this.filtered = true
            } else {
                MAP_CASES.mapbox.flyTo({
                    center: [0, 0],
                    zoom: 2
                })
                this.filtered = false
            }
        })
    }
    _filterCards( value ) {
        if ( value != 'all' ) {
            this.isotope.arrange({
                filter: `.fl__card--case[data-country="${value}"]`
            })
        } else {
            this.isotope.arrange({
                filter: `.fl__card--case`
            })
        }
    }

    _search() {
        event.preventDefault()

        _.addClass( this.DOM.section, 'is--searching' )

        API.post( this.endpoint, 
            new FormData( this.DOM.search.form )
        )
        .then( ( response ) => {
            console.log( response )
            if ( response.data.success ) {
                this._results( response )
            }
        })
        .catch( ( error ) => {
            console.log( error )
        })
        .then( () => {
            _.removeClass( this.DOM.section, 'is--searching' )
            _.addClass( this.DOM.section, 'is--searched' )
        })

        this.searched = true
    }

    _results( response ) {
        this._resultsCards( response )
        this._resultsMarkers( response )
        this._allowed()
    }

    _resultsMarkers( response ) {
        this.DOM.markers = _.selectAll( '.fl__marker' )
        this.DOM.markers.forEach( ( marker, key ) => {
            _.addClass( marker, 'fl__marker--hidden' )
        })

        if ( response.data.results.length > 0 ) {
            let results = response.data.results

            MAP_CASES.DOM.el.style.display = 'block'
            results.forEach( ( result ) => {
                let item = _.select( `.fl__marker[data-id="${result}"]` )
                _.removeClass( item, 'fl__marker--hidden' )
            })
        } else {
            MAP_CASES.DOM.el.style.display = 'none'
        }
    }

    _resultsCards( response ) {
        this.DOM.grid.items.forEach( ( item ) => {
            _.removeClass( item, 'fl__card--filtered' )
        })

        if ( response.data.results.length > 0 ) {
           let results = response.data.results

            results.forEach( ( result ) => {
                let item = _.select( `.fl__card--case[data-id="${result}"]` )
                _.addClass( item, 'fl__card--filtered' )
            })

            this.isotope.arrange({
                filter: '.fl__card--filtered'
            })


        } else {
            _.addClass( this.DOM.section, 'is--noresults' )
            this.isotope.arrange({
                filter: '.fl__card--noresults'
            })
        }
    }

    _clear() {
        
        this.DOM.grid.items.forEach( ( item ) => {
            _.removeClass( item, 'fl__card--filtered' )
        })

        this.DOM.markers = _.selectAll( '.fl__marker' )
        this.DOM.markers.forEach( ( marker, key ) => {
            _.removeClass( marker, 'fl__marker--hidden' )
        })

        MAP_CASES.DOM.el.style.display = 'block'
        _.removeClass( this.DOM.section, 'is--noresults' )
        _.removeClass( this.DOM.section, 'is--searched' )
        this.DOM.search.input.value = ''
        this.isotope.arrange({
            filter: '.fl__card--case'
        })

        this.searched = false
        this._allowed()
    }

    _allowed() {
        if ( this.searched === true ) {
            _.addClass( this.DOM.section, 'filter--disabled' )
            _.removeClass( this.DOM.section, 'search--disabled' )
        } else if ( this.filtered === true ) {
            _.addClass( this.DOM.section, 'search--disabled' )
            _.removeClass( this.DOM.section, 'filter--disabled' )
        } else {
            _.removeClass( this.DOM.section, 'search--disabled' )
            _.removeClass( this.DOM.section, 'filter--disabled' )
        }
    }
   
}

const CASES = new CasesClass()
export default CASES